export enum EvaluationPlanStatus {
  New,
  PendingApproval,
  Approved,
  Denied,
}
